// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 70
// module chunks = 0